import type { CompassProduct } from "../contexts/CompassContext";
import { getCompassProductEntity } from "../data/entity_sets/compassProductFromEntity";
import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";
import { getEntityByToken } from "../data/get_entity";

export const faireProductToCompassProduct = (
  product: FaireProductEntity
): CompassProduct => {
  const brand = product.brandToken
    ? getEntityByToken(product.brandToken, "brand")
    : undefined;
  const minimumOrderDollars = brand?.minimumOrderDollars;
  return {
    ...product,
    id: product.token,
    brandName: brand?.name ?? product.brandName,
    brandAvatarUrl: product.brandAvatarUrl ?? brand?.avatarUrl,
    rating: brand?.rating,
    reviewCount: brand?.reviewCount,
    isTopShop: brand?.isTopShop,
    freeShipping: product.freeShipping ?? brand?.isInsider,
    brandMinimum: minimumOrderDollars,
    minOrder:
      typeof minimumOrderDollars === "number" && !isNaN(minimumOrderDollars)
        ? `$${minimumOrderDollars} min`
        : "$250 min",
    priceDollars: product.priceDollars,
    price: product.priceDollars,
    msrpDollars: product.msrpDollars,
    msrp: product.msrpDollars,
    tags: product.tags ?? [],
  };
};

export const compassProductFromProductToken = (
  token: string
): CompassProduct | undefined => {
  const product = getCompassProductEntity(token);
  if (!product) {
    return undefined;
  }
  return faireProductToCompassProduct(product);
};
